type IdReducerAction =
  | { type: 'reset' }
  | { productId: number; type: 'add' }
  | { productId: number; type: 'remove' };

export const idReducer = (
  state: number[],
  action: IdReducerAction
): number[] => {
  switch (action.type) {
    case 'add': {
      if (state.includes(action.productId)) {
        return state;
      }
      return [...state, action.productId];
    }
    case 'remove': {
      const ind = state.findIndex((pId) => pId === action.productId);
      if (ind < 0) {
        return state;
      }
      return state.splice(ind, 1);
    }
    case 'reset': {
      return [];
    }
    default: {
      return state;
    }
  }
};
